import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet-async';
import PageHero from '@components/hero';
import Heading from '@components/pageHeading';
import { SectionHeading } from '@components/Common';
import { Layout, Container } from 'layouts';

// Assets
import headerImage from '@assets/services/react-dev/react-dev-header.jpg';

import AnalyticsIcon from '@assets/services/react-dev/analytics.svg';
import CICDToolsIcon from '@assets/services/react-dev/ci-cd-tools.svg';
import CrashReportingIcon from '@assets/services/react-dev/crash-reporting.svg';
import StoreManagementIcon from '@assets/services/react-dev/fe-store-management.svg';
import NotificationServiceIcon from '@assets/services/react-dev/notifications-services.svg';
import TestingIcon from '@assets/services/react-dev/testing.svg';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  margin-top: 30px;
`;

const IconElem = styled.div`
  width: 200px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: start;
  flex-flow: column;
  margin: 15px 20px;
  .process-section {
    width: 200px;
  }
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    width: 180px;
  }
`;

const Label = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

const ProcessWrapper = styled.div`
  background-color: ${props => props.theme.colors.primary.lighter};
`;

const ProcessIconElem = styled(IconElem)`
  width: 150px;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    width: 90px;
  }
  svg {
    margin-bottom: 20px;
  }
`;

const DataVisualization = () => {
  return (
    <Layout>
      <Helmet title={'React'} />
      <PageHero image={headerImage} />
      <Heading title="React and React Native Development" noHeadingIcon={true}>
        <p>
          In this modern market, whatever pleases the eyes has more chances to
          sell well. Yes, it's harsh but it's the truth. So how would your app
          stand out? Worry not, we got you. Our team has expertise in React and
          React Native.
        </p>
        <p>
          What is React? It is some techy-techy coding language which is used
          for building interactive user interfaces (UIs). It makes it painless
          to create gratifying UIs and is the need-of-the-hour in the field of
          UI development.
        </p>
        <p>
          Ok, cool, now what is React Native? A few years ago, Mark Zuckerberg
          realised that they made a huge mistake on focusing on HTML instead of
          something which could've been more native for the devices. In easy
          language, React Native combines the best parts of native development
          with React, a best-in-class JavaScript library for building user
          interfaces. It is used to develop applications by enabling developers
          to use React along with native platform capabilities.
        </p>
        <p>
          Now you might be thinking, ok, nice, you can make my app look wow, but
          what about the functionality? Well, working on React and React Native
          is a few of the many specialities we have. Our team understands that
          no matter how interactive an app is, it won't stand a chance if it
          doesn't function what it is supposed to do. And that's top companies
          and start-ups choose CodeMyMobile’s React Native Developers for their
          mission-critical mobile application.
        </p>
      </Heading>
      <ProcessWrapper>
        <Container>
          <SectionHeading>Why React/React Native?</SectionHeading>
          <IconWrapper>
            <ProcessIconElem>
              <StoreManagementIcon />
              <Label>Frontend Store / State Management</Label>
            </ProcessIconElem>
            <ProcessIconElem>
              <NotificationServiceIcon />
              <Label>Notifications Services</Label>
            </ProcessIconElem>
            <ProcessIconElem>
              <AnalyticsIcon />
              <Label>Analytics</Label>
            </ProcessIconElem>
            <ProcessIconElem>
              <CrashReportingIcon />
              <Label>Crash Reporting</Label>
            </ProcessIconElem>
            <ProcessIconElem>
              <CICDToolsIcon />
              <Label>CI / CD Deployment Tools support</Label>
            </ProcessIconElem>
            <ProcessIconElem>
              <TestingIcon />
              <Label>Testing support</Label>
            </ProcessIconElem>
          </IconWrapper>
        </Container>
      </ProcessWrapper>
    </Layout>
  );
};

export default DataVisualization;
